import { View } from 'react-native'
import { Link } from 'expo-router'
import Page from '@shell/Page'
import Typography from '@ui/typography'

const Path = ({
  path,
  label,
}: {
  path: string | { pathname: string }
  label: string
}) => (
  <Link href={path}>
    <View>
      <Typography variant="MDB">{label}</Typography>
      <Typography variant="XS" className="tracking-[0] color-desc">
        {typeof path === 'string' ? path : path.pathname}
      </Typography>
    </View>
  </Link>
)

export default function DevRouterPage() {
  return (
    <Page stage="dev">
      <View className="flex gap-8 p-16">
        <Path label="Staff" path="/staff/panel" />
        <Path label="Staff Customers" path="/staff/customers" />
        <Path label="Summary" path="/order/summary" />
        <Path label="Discounts" path="/order/discounts" />
        <Path label="Checkout" path="/checkout" />
        <Path
          label="Create External Prescription"
          path="/vision/prescription/manual"
        />
        <Path label="Chat" path="/staff/chat" />
        <Path label="Temple Search" path="/frame/temple/search" />
        <Path label="Temple Select" path="/frame/temple/select" />
        <Path label="Stock" path="/frame/stock" />
        <Path label="Notifications Test" path="/dev/notifications" />
      </View>
    </Page>
  )
}
